import apiClient from './client'
import type { QueueStatus, QueueDashboard } from '@/types'

export const queueApi = {
  getStatus: async (): Promise<QueueStatus> => {
    const response = await apiClient.get<QueueStatus>('/queue/status')
    return response.data
  },

  getDashboard: async (): Promise<QueueDashboard> => {
    const response = await apiClient.get<QueueDashboard>('/queue/dashboard')
    return response.data
  },

  getActive: async (): Promise<{ active_conferences: QueueStatus['active_conferences'] }> => {
    const response = await apiClient.get('/queue/active')
    return response.data
  },

  getProcessing: async (): Promise<{ processing_sessions: QueueStatus['processing_sessions'] }> => {
    const response = await apiClient.get('/queue/processing')
    return response.data
  },

  getWaiting: async (): Promise<{ waiting_sessions: QueueStatus['waiting_sessions'] }> => {
    const response = await apiClient.get('/queue/waiting')
    return response.data
  },

  getRecent: async (): Promise<{ recent_sessions: QueueStatus['recent_sessions'] }> => {
    const response = await apiClient.get('/queue/recent')
    return response.data
  },

  checkHealth: async (): Promise<{ status: 'healthy' | 'unhealthy'; whisper_url?: string; error?: string }> => {
    const response = await apiClient.get('/queue/health')
    return response.data
  },
}
